import { DEFAULT_INVALID, DEFAULT_REPLACE, PERCENT_EXPRESSION } from 'cyprus/constants';
import { FORMAT_TYPE } from 'cyprus/enums';
import { FormatValue, FormatValueOptions } from 'cyprus/types';
import { abbreviateNumber, invalidNumber } from 'cyprus/utils';

export const formatPercent = (value: FormatValue, options: FormatValueOptions): string => {
  const { format } = options;
  const ignore = options.ignore || [];
  const number = Number(value);
  const decimal = Number(options.decimal || 0);
  const match = ignore.includes(String(value));

  if (match) {
    return options.replace || DEFAULT_REPLACE;
  }

  if (invalidNumber(value)) {
    return options.invalid || DEFAULT_INVALID;
  }

  const negative = Math.sign(number) === -1;
  const abs = Math.abs(number) * 100;

  switch (format) {
    case FORMAT_TYPE.PERCENT: {
      // determine nearest decimal with max decimal passed in
      // ex. decimals = 2, 12.02321 => 12.02%
      // ex. decimals = 2, 12.2 => 12.2%
      // ex. decimals = 2, 12.000003 => 12%
      const rounded = Math.round(abs * Math.pow(10, decimal)) / Math.pow(10, decimal);

      if (negative) {
        return `-${String(rounded)
          .replace(PERCENT_EXPRESSION, ',')
          .replace(/(\.\d*),/g, '$1')}%`;
      }
      return `${String(rounded)
        .replace(PERCENT_EXPRESSION, ',')
        .replace(/(\.\d*),/g, '$1')}%`;
    }
    case FORMAT_TYPE.PERCENT_ABBREVIATED: {
      if (negative) {
        return `-${abbreviateNumber(abs, decimal)}%`;
      }
      return `${abbreviateNumber(abs, decimal)}%`;
    }
    case FORMAT_TYPE.PERCENT_FIXED: {
      if (negative) {
        return `-${String(abs.toFixed(decimal))
          .replace(PERCENT_EXPRESSION, ',')
          .replace(/(\.\d*),/g, '$1')}%`;
      }
      return `${String(abs.toFixed(decimal))
        .replace(PERCENT_EXPRESSION, ',')
        .replace(/(\.\d*),/g, '$1')}%`;
    }
    default:
      return String(value || '');
  }
};
